<mat-form-field class="mat-form-field-fluid placeholder-truncate">
    <mat-label>{{label}}</mat-label>
    <input matInput [matDatepicker]="picker"
           [(ngModel)]="dateOfBirth"
           [attr.data-test-id]="testId + '-input'"
           [required]="!optional" [name]="name" [id]="id || name"
           #csDate="ngModel"
           [min]="minDate" [max]="maxDate"
           [disabled]="disabled"
           [readonly]="readonly"
           numbersAndSlashOnly
           (dateChange)="onChangeDate($event)"
           (dateInput)="onChangeDate($event)"
    >
    <mat-datepicker-toggle matIconSuffix [for]="picker" [attr.data-test-id]="testId + '-calendar'" [id]="name" *ngIf="!readonly && !disabled">
        <span matDatepickerToggleIcon>
            <sm-icon name="calender"></sm-icon>
        </span>
    </mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    <mat-hint [attr.data-test-id]="testId + '-hint'" [hidden]="!hint">{{hint}}</mat-hint>
    <mat-error [attr.data-test-id]="testId + '.required-error'" *ngIf="dateEleRef?.control.hasError('required') || dateEleRef?.control.hasError('matDatepickerParse')">Please enter the {{label}}.</mat-error>
    <mat-error [attr.data-test-id]="testId + '.min-error'" *ngIf="dateEleRef?.control.hasError('matDatepickerMin')">{{label}} can not be less than {{minDate | date: 'MM/dd/YYYY'}}</mat-error>
    <mat-error [attr.data-test-id]="testId + '.max-error'" *ngIf="dateEleRef?.control.hasError('matDatepickerMax')">{{label}} can not be greater than {{maxDate | date: 'MM/dd/YYYY'}}</mat-error>
</mat-form-field>
